import React from 'react';
import * as S from './styled';

export const BookmarkIconNotSaved = () => (
  <S.IconStyledNotBookmarked icon="bookmark-ghost" size="24" />
);

export const BookmarkIconSaved = () => (
  <S.IconStyledBookmarked icon="bookmark" size="24" />
);
